import React from 'react';
import { Dropdown, Button } from '@cimpress/react-components';

const DrawerDemo = () => (
  <div>
    <Dropdown title="I'm a dropdown">
      <button>Stuff</button>
      <button>Things</button>
      <hr />
      <button disabled>Other things</button>
    </Dropdown>

    <Dropdown
      title={
        <span className="h3" style={{ margin: '0' }}>
          &#8285;
        </span>
      }
      variant="simple"
    >
      <Button variant="anchor">Stuff</Button>
      <Button variant="anchor">Things</Button>
      <hr />
      <Button variant="anchor" disabled>
        Other things
      </Button>
    </Dropdown>

    <Dropdown
      title={
        <span className="h3" style={{ margin: '0' }}>
          &#8285;
        </span>
      }
    >
      <Button variant="anchor">Stuff</Button>
      <Button variant="anchor">Things</Button>
      <hr />
      <Button variant="anchor" disabled>
        Other things
      </Button>
    </Dropdown>
  </div>
);

export default DrawerDemo;
